var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "752EB02D-3471-4811-B07F-98D4B77F0D6A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "v3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "[phase-1]-quote-start-desktop",
    transform: "translate(-444.000000, -974.000000)",
    fill: "#0B7BFB"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2733\\uFE0F-molecules/summary-page/driver-details",
    transform: "translate(360.000000, 856.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "title-row",
    transform: "translate(24.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDB1-Button",
    transform: "translate(44.000000, 87.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plus-icn-blue",
    transform: "translate(16.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8640069,6.77 L1.13599314,6.77 C0.508601451,6.77 0,7.32068976 0,8 C0,8.67931024 0.508601451,9.23 1.13599314,9.23 L14.8640069,9.23 C15.4913985,9.23 16,8.67931024 16,8 C16,7.32068976 15.4913985,6.77 14.8640069,6.77 Z",
    id: "Rectangle-20",
    transform: "translate(8.000000, 8.000000) rotate(-90.000000) translate(-8.000000, -8.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8640069,6.77 L1.13599314,6.77 C0.508601451,6.77 0,7.32068976 0,8 C0,8.67931024 0.508601451,9.23 1.13599314,9.23 L14.8640069,9.23 C15.4913985,9.23 16,8.67931024 16,8 C16,7.32068976 15.4913985,6.77 14.8640069,6.77 Z",
    id: "Rectangle-20",
    transform: "translate(8.000000, 8.000000) scale(-1, 1) translate(-8.000000, -8.000000) "
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.52daa0190a89dca311e05118b0caeb43.svg";
export { ForwardRef as ReactComponent };